import React from 'react';
import {Carousel} from "react-responsive-carousel";

class Testimonial extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            messageOverlayPosition: 0,
            testimonialList: []
        };
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            testimonialList: nextProps.testimonialList
        })
    }

    handleSelectedMessageItem = (e) => {
        this.setState({messageOverlayPosition: e});
    }

    returnPetsName(value) {
        let data = value && value.pets || []
        return `, Owner of ${data}`;
    }

    render() {
        return (

            <section className="wrap-top" id="community">
                <div className="content">
                    <h2 className="title" id="testimonialHeader">Testimonials</h2>
                    <ul className="testimonial-list">
                        <Carousel
                            selectedItem={this.state.messageOverlayPosition}
                            onChange={(e) => {
                                this.handleSelectedMessageItem(e)
                            }}
                        >
                            {this.state.testimonialList.map((testimonial, index) => (
                                <figure className="testimonial-list" key={index}>
                                    <blockquote>{testimonial.description}</blockquote>
                                    <figcaption>
                                        &mdash; {testimonial.parent_name}
                                        <cite>{this.returnPetsName(testimonial)}</cite>
                                    </figcaption>

                                </figure>
                            ))}
                        </Carousel>
                    </ul>
                </div>
            </section>
        );
    }
}

export default Testimonial;
